import axios from "axios";
import { clearLoggedInUserInvalidCredential, clearLoggedInUserInvalidCredentialTokenExpired } from "app/utils/utils";
import { toast } from "react-toastify";

export const domainUrl = "https://timetango.in";
// export const baseURL = "http://129.154.237.106:8000";
export const baseURL = "https://timetango.in/api";
// export const baseURL = "http://localhost:8000";
// export const baseURL = "https://sahbazar.in/api";

// Create Axios instances
export const axiosApiInstanceAuth = axios.create({ baseURL });
export const axiosApiInstance = axios.create({ baseURL });
export const axiosMultipart = axios.create({ baseURL });

// Flag to track if session expired message has already been shown
let sessionExpiredErrorShown = false;

const requestInterceptor = async (config) => {
  try {
    const token = localStorage.getItem("tokan");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  } catch (err) {
    console.error("Request interceptor failed:", err);
    return Promise.reject(err);
  }
};

const responseInterceptor = (response) => response;

export const errorInterceptor = (error) => {
  if (!error.response) {
    toast.error("Network Error. Please check your connection!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "networkError",
    });
    clearLoggedInUserInvalidCredentialTokenExpired();
    return Promise.reject(error);
  }

  const { status, data, config } = error.response;
  const errorMessage = data?.message || "An unexpected error occurred!";
  const toastId = `error_${status}_${config?.url}`;

  switch (status) {
    case 502:
      toast.error("Bad Gateway. Server might be down!", {
        position: toast.POSITION.TOP_RIGHT,
        toastId,
      });
      clearLoggedInUserInvalidCredentialTokenExpired();
      break;
    case 401:
      if (!sessionExpiredErrorShown) {
        sessionExpiredErrorShown = true;
        if (errorMessage) {
          toast.error(errorMessage || "Unauthorized. Please log in again.", {
            position: toast.POSITION.TOP_RIGHT,
            toastId,
          });
          setTimeout(function () {
            clearLoggedInUserInvalidCredentialTokenExpired();
          }, 1000);
        } else {
          toast.error(errorMessage || "Unauthorized. Please log in again.", {
            position: toast.POSITION.TOP_RIGHT,
            toastId,
          });
          setTimeout(function () {
            clearLoggedInUserInvalidCredentialTokenExpired();
          }, 1000);
        }
      }
      break;
    default:
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
        toastId,
      });
  }

  return Promise.reject(error);
};

// Attach interceptors
axiosApiInstanceAuth.interceptors.request.use(
  requestInterceptor,
  Promise.reject
);
export default axiosApiInstance.interceptors.request.use(
  requestInterceptor,
  Promise.reject
);
axiosMultipart.interceptors.request.use(async (config) => {
  config = await requestInterceptor(config);
  config.headers["Content-Type"] = "multipart/form-data";
  return config;
}, Promise.reject);

axiosApiInstance.interceptors.response.use(
  responseInterceptor,
  errorInterceptor
);
axiosApiInstanceAuth.interceptors.response.use(
  responseInterceptor,
  errorInterceptor
);
axiosMultipart.interceptors.response.use(responseInterceptor, errorInterceptor);

// Reset session expired error flag when user logs in again (or session is refreshed)
export const resetSessionExpiredErrorFlag = () => {
  sessionExpiredErrorShown = false;
};
